<template lang="pug">
  v-content
    v-container(fluid grid-list-md)
      ImportManualOrderForm(@importedFile="importedFile" @upload="clearWorkData")
      ProgressBar
      ManualOrderWorkList(class="mt-4" ref="workList")
</template>

<script>
import ImportManualOrderForm from "@/components/import/ImportManualOrderForm";
import ManualOrderWorkList from "@/components/import/ManualOrderWorkList";
import ProgressBar from "@/components/common/ProgressBar";

export default {
  components: {
    ImportManualOrderForm,
    ManualOrderWorkList,
    ProgressBar
  },
  methods: {
    importedFile() {
      this.$refs.workList.loadWorkDataAll();
      this.$refs.workList.fetchWorkListCount();
    },
    clearWorkData() {
      this.$refs.workList.clearWorkData();
    }
  }
};
</script>
